import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Grid, GridRow, MenuItem, Spacer, Typography } from '@emburse/embark-core';
import { useEffect, useState } from 'react';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { IconMenu, SkeletonDataGrid } from '../../components';
import useLoadingOverlay from '../../hooks/useLoadingOverlay';
import { getEmployeeAchAccount } from '../../api/employeeAchAccount';
function EmpWiseAccount() {
    useTranslation();
    const { applyLoadingState, removeLoadingState } = useLoadingOverlay();
    const [achAccounts, setAchAccounts] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        const initialize = async () => {
            applyLoadingState();
            const accountResponse = await getEmployeeAchAccount();
            const account = await accountResponse.json();
            setAchAccounts(account.Id > 0 ? [account] : []);
            setIsInitialized(true);
            removeLoadingState();
        };
        initialize();
    }, [applyLoadingState, removeLoadingState]);
    const getColumns = () => {
        const columns = [];
        return columns.concat([
            {
                field: 'accountHolder',
                headerName: 'Account Holder',
                minWidth: 258,
                renderCell: (cell) => _jsx("span", { children: cell.row.Name })
            },
            {
                field: 'description',
                headerName: 'Description',
                minWidth: 258,
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                renderCell: (cell) => _jsx("span", { children: " " })
            },
            {
                field: 'currency',
                headerName: 'Currency',
                width: 258,
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                renderCell: (cell) => _jsx("span", { children: "USD" }) // Temporary placeholder
            },
            {
                field: 'accountType',
                headerName: 'Account Type',
                minWidth: 258,
                renderCell: (cell) => (_jsx("span", { children: cell.row.AccountType === 0 ? 'Checking' : 'Savings' }))
            },
            {
                field: 'action',
                width: 188,
                renderHeader: () => _jsx("span", { children: "\u00A0" }),
                renderCell: () => {
                    const setSelectedAction = () => {
                        // Placeholder function
                        // TODO: Implement setSelectedCardAccount
                    };
                    return (_jsx("div", { style: {
                            width: '100%',
                            textAlign: 'right'
                        }, children: _jsx(IconMenu, { anchorHorizontalPosition: "left", onOpen: () => setSelectedAction(), children: _jsx(MenuItem, { children: "Edit" }) }) }));
                }
            }
        ]);
    };
    return (_jsxs(SingleColumnLayout, { children: [_jsx(Typography, { variant: "h4", children: "Direct Deposit Account Settings" }), _jsx(Spacer, { size: 16 }), _jsxs(Card, { "data-qa": "payment-accounts-datagrid", children: [_jsx(GridRow, { justifyContent: "space-between", direction: "row", children: _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "subtitle1", children: $t('Payment Accounts') }) }) }), _jsx(Spacer, { size: 16 }), _jsx(GridRow, { children: _jsx(SkeletonDataGrid, { loading: !isInitialized, autoHeight: true, rowHeight: 60, sx: { width: '100%' }, pageSizeOptions: [1], rows: achAccounts.map((row, i) => ({ ...row, id: i })) || [], noRowsEmptyStateProps: {
                                text: $t('No payment accounts found. Add a bank account to get started.')
                            }, columns: getColumns() || [] }) })] })] }));
}
export default EmpWiseAccount;
